import Vue from 'vue'
import App from './App.vue'
import router from './router'
import routerYD from './router/indexYD'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Vant from 'vant';
// import 'quill/dist/quill.core.css'
import 'vant/lib/index.css'
import ElementUI from 'element-ui'; // 2.1引入结构
import 'element-ui/lib/theme-chalk/index.css'; // 2.2引入样式
import less from 'less'
// 使用组件
import VueVideoPlayer from 'vue-video-player'
//打印插件
import Print from '../src/request/print'
Vue.use(Print)
// 引入样式
import 'video.js/dist/video-js.css'
import 'vue-video-player/src/custom-theme.css'
Vue.use(VueVideoPlayer)
Vue.use(less)
Vue.use(Vant);
Vue.use(ElementUI);
Vue.config.productionTip = false
Vue.use(VueAxios, axios)
const ISMOBILE = function () {
	const flag = navigator.userAgent.match(
		/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
	);
	return flag;
}

// const clientWidth = document.documentElement.clientWidth
new Vue({
  render: h => h(App),
  router: ISMOBILE()? routerYD : router
  // router: clientWidth<751 ? routerYD : router,
}).$mount('#app')

